import React from 'react'
import classnames from 'classnames'

import styles from './styles.css'

const Answer = () => (
  <div>
    <p className={classnames(styles.text, styles.section)}>
      Recognizing and acknowledging our emotions, whether work-related or life related, is a fundamental step for self-regulation instead of being repeatedly triggered by these emotions, feeling overly stressed, and being ineffective in dealing with others. This is a core aspect of emotional intelligence which makes this habit of paramount importance.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      How do we become more aware of our emotions in the first place so we can better manage them instead of being repeatedly triggered by them? There are two approaches that we recommend, one being mindfulness practices and the other being purposeful reflection.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      For now, we are going to focus on what steps to consider when we notice unpleasant emotions that are hindering us and preventing us from being effective in our own work and/or working with other people.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      The steps, which we refer to as the <span className={styles.bold}>Mindfulness @Work 5-Steps Formula</span> and which are extracted from our Mindfulness @Work workshop* include:
    </p>

    <p className={classnames(styles.section)}>
      <p className={styles.text}>1. Labeling</p>
      <p className={styles.text}>2. Ranking</p>
      <p className={styles.text}>3. Accepting</p>
      <p className={styles.text}>4. Reframing</p>
      <p className={styles.text}>5. Refocusing</p>
    </p>

    <table className={classnames(styles.section)}>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Labeling</td>
        <td className={classnames(styles.text, styles.tableData)}>Pausing for a brief mindful moment, acknowledging the emotion, and naming it--such as this is “Fear,” “Anxiety,” or “Sadness” (remember we are learning how to manage unpleasant emotions here and hence these examples).</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Ranking</td>
        <td className={classnames(styles.text, styles.tableData)}>Ranking the event that caused the emotion between 1 and 10 where 1 would be the most tragic thing that can happen and 10 being the happiest best thing that can happen and all shades in between.</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Accepting</td>
        <td className={classnames(styles.text, styles.tableData)}>Pausing for another mindful moment and asking the question: “What would it be like to let this emotion ‘be’ for now and feel it?” Therefore, instead of resisting the emotion, trying to fix it, or maybe suppress it, this would consist of letting the feeling be and let it go where it needs to go--replacing resistance with curiosity!</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Reframing</td>
        <td className={classnames(styles.text, styles.tableData)}>This consists of asking the question: “What can I learn from this emotion and this event?” This would be turning the situation into a learning opportunity. In addition to learning that this feeling is not going to “kill us” (i.e. putting things in perspective), it likely we are going to also learn about our triggers--what triggered this kind of emotion? This learning is the ultimate in self-awareness. Over time, it is likely to enable deeper work on the beliefs underlying these triggers.</td>
      </tr>
      <tr>
        <td className={classnames(styles.text, styles.label, styles.tableData)}>Refocusing</td>
        <td className={classnames(styles.text, styles.tableData)}>This step consists of bringing our attention back to where we want to be, which depends on the context we are in. If we were working on a task when we experienced the emotion, it is time to go back and focus on the task. If we are having a conversation with someone, it would be focusing on that conversation.</td>
      </tr>
    </table>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Capturing emotions in this form</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Emotion field:</span> You can select one of the emotions in the list, or simply type an emotion on your own. The list of emotions provided represents what is considered to be the primary emotions that are common.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Rank field:</span> This is where you rank the emotion (see ranking details above).
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Reflection field:</span> This is where you would pause and conduct steps 3, 4, and 5 if needed, and jot down some insights from these steps (see more details about these steps above).
    </p>
    <p className={classnames(styles.text, styles.section)}>
      You can later review the various emotions and reflections that you captured in the Log Page, so you can have your “mega” reflection and deeper insights over time.
    </p>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>How about positive emotions?</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      We encourage you to capture them as well. If they are related to the actual task, you can use the Engagement Tab in the + Form. Otherwise, you can capture them in the Emotions Tab and rank them positively on the scale:)
    </p>
    <p className={classnames(styles.text, styles.section, styles.italic)}>
      *Learn more about the <a className={styles.link} target="_blank" href="https://www.people-onthego.com/mindfulness-at-work">Mindfulness @Work Workshop</a> and Webinar as an additional resource to help you deepen the various habits we are working on in the 21-Day Challenge.
    </p>
  </div>
)

export default Answer



// WEBPACK FOOTER //
// ./src/components/categoryTabs/emotionsForm/answer/index.js